module.exports = __webpack_public_path__ + "static/img/usb_off.f6e627d2.png";